import type { SVGProps } from "react";
export default function SvgSortUpNumbers(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-arrow-up01-icon lucide-arrow-up-0-1"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="m3 8 4-4 4 4" />
			<path d="M7 4v16" />
			<rect width={4} height={6} x={15} y={4} ry={2} />
			<path d="M17 20v-6h-2" />
			<path d="M15 20h4" />
		</svg>
	);
}
